export default {
  'menu.third-platform.wechat': '微信',
  'menu.third-platform.wechat.public-accounts': '微信公众号',
  'menu.third-platform.wechat.mini-programs': '微信小程序',
  'menu.third-platform.fei-shu.apps': '应用管理',
  'menu.third-platform.work-wx.group-chat': '客户群',

  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',

  'menu.common': '公共平台',
  'menu.common.user': '用户管理',

  'menu.traffic': '流量平台',
  'menu.traffic.traffic-track': '例子管理',
  'menu.traffic.material-trace': '素材溯源',
  'menu.traffic.traffic-management': '流量管理',
  'menu.traffic.traffic-management.channel-conversion': '渠道转化数据',
  'menu.traffic.traffic-management.channel-rules': '渠道归因规则',
  'menu.traffic.material-management': '素材管理',
  'menu.traffic.landing-page': '落地页配置',
  'menu.traffic.work-wx-contact': '企微加好友配置',
  'menu.traffic.material-management.baidu': '百度智投报告',
  'menu.traffic.material-management.baidu-video': '百度视频报告',
  'menu.traffic.material-management.xiaohongshu': '小红书列表',
  'menu.traffic.material-management.qianchuan': '抖音素材',
  'menu.traffic.material-management.ieh5': '视频号素材',

  'menu.sale': '营销平台',
  'menu.sale.sale-class': '班级管理',
  'menu.sale.sale-class-user': '班级成员',
  'menu.sale.sale-order': '订单管理',
  'menu.sale.sale-order.sale-pay-order': '收款记录',
  'menu.sale.sale-order.sale-manual-pay-order': '补录订单',
  'menu.sale.sale-setting': '营销配置',
  'menu.sale.sale-setting.sale-camp': '营期管理',

  'menu.backend': '服务平台',
  'menu.backend.level-2-users': '2阶用户数据明细',
  'menu.backend.level-3-users': '3阶用户数据明细',
  'menu.backend.level-4-users': '4阶用户数据明细',
  'menu.backend.backend-order': '订单管理',
  'menu.backend.backend-order.backend-pay-order': '收款记录',
  'menu.backend.backend-order.backend-manual-pay-order': '补录订单',
  'menu.backend.backend-order.backend-refund-order': '退款记录',
  'menu.backend.backend-setting': '后端配置',
  'menu.backend.backend-setting.backend-camp': '场次管理',
  'menu.backend.backend-member': '成员管理',
  'menu.backend.backend-member.backend-member-user': '后端成员',

  'menu.bill': '财务中台',
  'menu.bill.order': '订单管理',
  'menu.bill.order.order-list': '订单列表',
  'menu.bill.order.trade-order': '交易订单',
  'menu.bill.order.pay-order': '收款记录',
  'menu.bill.order.refund-order': '退款记录',
  'menu.bill.sale-order': '营销订单',
  'menu.bill.sale-order.sale-pay-order': '营销收款',
  'menu.bill.sale-order.sale-manual-pay-order': '营销补录订单',
  'menu.bill.backend-order': '后端订单',
  'menu.bill.backend-order.backend-pay-order': '后端收款',
  'menu.bill.backend-order.backend-manual-pay-order': '后端补录订单',
  'menu.bill.statement': '账单',
  'menu.bill.statement.bank-statement': '银行流水',
  'menu.bill.statement.tang-lang-statement': '螳螂流水',
  'menu.bill.statement.order': '全部订单',
  'menu.bill.statement.landing-page-order': '落地页订单',
  'menu.bill.statement.work-wx-order': '企微收款订单',

  'menu.data': '数据中台',
  'menu.data.customer-management': '客户管理',
  'menu.data.customer-management.customer-tag': '客户标签',
  'menu.data.customer-management.customer-list': '客户列表',
  'menu.data.customer-management.customer-stage': '客户阶段',
  'menu.data.customer-management.customer-field': '客户字段',
  'menu.data.customer-management.customer-source': '来源管理',
  'menu.data.customer-management.customer-channel': '渠道管理',
  'menu.system.project-management': '项目管理',
  'menu.system.project-management.project-list': '项目列表',
  'menu.data.automation-workflow': '自动化工作流',
  'menu.data.automation-workflow.workflow-list': '工作流列表',
  'menu.data.automation-workflow.workflow-config': '配置工作流',
  'menu.sale.sale-order.order-center': '订单中心',
  'menu.data.data-track': '全链路用户数据',

  'menu.third-platform': '第三方平台',
  'menu.third-platform.xing-cheng': '星橙',
  'menu.third-platform.xing-cheng.account': '星橙账号',
  'menu.third-platform.xing-cheng.traffic-order': '例子订单',
  'menu.third-platform.tang-lang': '螳螂',
  'menu.third-platform.tang-lang.traffic-order': '例子订单',
  'menu.third-platform.tang-lang.customer': '客户数据',
  'menu.third-platform.tang-lang.refund-order': '退款订单',
  'menu.third-platform.tang-lang.pay-order': '支付订单',
  'menu.third-platform.tang-lang.account': '螳螂账号',
  'menu.third-platform.tang-lang.scheduled-task': '定时任务',
  'menu.third-platform.tang-lang.product': '商品列表',
  'menu.third-platform.tang-lang.camp-learning': '训练营',
  'menu.third-platform.fei-shu': '飞书',
  'menu.third-platform.fei-shu.traffic-order': '例子订单',
  'menu.third-platform.fei-shu.sale-order': '销售订单',
  'menu.third-platform.fei-shu.backend-sale-order': '后端销售订单',
  'menu.third-platform.fei-shu.table-record': '飞书记录',
  'menu.third-platform.fei-shu.rpa-order': 'RPA订单',
  'menu.third-platform.work-wx': '企业微信',
  'menu.third-platform.work-wx.work-wx-corp': '企业',
  'menu.third-platform.work-wx.work-wx-user': '成员',
  'menu.third-platform.work-wx.work-wx-external-user': '客户',
  'menu.third-platform.work-wx.work-wx-follow-user': '跟进关系',
  'menu.third-platform.work-wx.external-pay-bill': '对外收款账单',
  'menu.third-platform.work-wx.external-refund-order': '企微退款订单',
  'menu.third-platform.work-wx.work-wx-fund-flow': '资金流水',
  'menu.third-platform.wechat-pay': '微信支付',
  'menu.third-platform.wechat-pay.wechat-pay-merchant-account': '商户账号',
  'menu.third-platform.wechat-pay.wechat-pay-fund-flow': '资金流水',
  'menu.third-platform.wechat-pay.wechat-pay-trade-bill': '交易账单',
  'menu.third-platform.zhu-ge': '诸葛',
  'menu.third-platform.zhu-ge.order': '诸葛订单',
  'menu.third-platform.zhu-ge.author-report-day': '作者日报',
  'menu.third-platform.zhu-ge.author-video-plan-day': '作者计划日报',
  'menu.third-platform.zhu-ge.report-day': '投放日报',
  'menu.third-platform.wx-shop': '微信小店',
  'menu.third-platform.wx-shop.funds-flow': '资金流水',
  'menu.third-platform.wx-shop.order-flow': '订单流水',
  'menu.third-platform.dou-gong': '斗拱平台',
  'menu.third-platform.dou-gong.trade-bill': '交易账单',
  'menu.third-platform.bank': '银行',
  'menu.third-platform.bank.bank-statement': '银行流水',
  'menu.third-platform.bank.union-pay-flow': '银联流水',
  'menu.third-platform.baidu': '百度',
  'menu.third-platform.baidu.app': '应用列表',
  'menu.third-platform.baidu.authorization': '授权账号',
  'menu.third-platform.baidu.account-report': '投放报表',
  'menu.third-platform.baidu.video-report': '视频报告',
  'menu.third-platform.xiaohongshu': '小红书',
  'menu.third-platform.xiaohongshu.app': '应用列表',
  'menu.third-platform.xiaohongshu.authorization': '授权账号',
  'menu.third-platform.xiaohongshu.account': '投放账号',
  'menu.third-platform.xiaohongshu.note-list': '笔记列表',
  'menu.third-platform.xiaohongshu.account-report': '账户报表',
  'menu.third-platform.xiaohongshu.campaign-report': '计划报表',
  'menu.third-platform.xiaohongshu.creative-report': '素材报表',
  'menu.third-platform.qianchuan': '巨量千川',
  'menu.third-platform.qianchuan.app': '应用列表',
  'menu.third-platform.qianchuan.authorization': '授权账号',
  'menu.third-platform.qianchuan.authorized-account': '授权主体',
  'menu.third-platform.qianchuan.account': '投放账号',
  'menu.third-platform.qianchuan.account-report': '报表明细',
  'menu.third-platform.qianchuan.report-summary': '报表汇总',
  'menu.third-platform.qianchuan.material-report': '素材报表',
  'menu.third-platform.ieh5': '海豚',
  'menu.third-platform.ieh5.account': '账号配置',
  'menu.third-platform.ieh5.ad-account': '投放号',
  'menu.third-platform.ieh5.order-management': '订单管理',
  'menu.third-platform.ieh5.issued-data': '出单数据',
  'menu.third-platform.ieh5.material-attribution': '素材溯源结果',
  'menu.third-platform.ieh5.operation-report': '运营报表-视频',
  'menu.third-platform.ieh5.operation-shipinhao-report': '运营报表-投放号',
  'menu.third-platform.ieh5.finance-report': '财务报表',
  'menu.third-platform.ieh5.placement-data': '投放数据',
  'menu.third-platform.ieh5.material-report': '素材数据',

  'menu.frontend': '销售平台',
  'menu.frontend.experience-camp-users': '1阶用户数据明细',
  'menu.frontend.auto-ops': '自动化运营',
  'menu.frontend.auto-ops.hosted-wx': '托管微信号管理（探鲸）',
  'menu.frontend.auto-ops.hosted-wx-zhonghui': '托管微信号管理（中荟）',
  'menu.frontend.auto-ops.juzi-account': '句子账号管理',
  'menu.frontend.auto-ops.sop-template': '社群SOP模板',
  'menu.frontend.auto-ops.sop-template-edit': '编辑模板',
  'menu.frontend.auto-ops.sop-template-edit-id': '编辑模板',
  'menu.frontend.auto-ops.task': '任务管理',
  'menu.frontend.auto-ops.task-create': '新建任务',
  'menu.frontend.auto-ops.task-detail': '任务详情',
  'menu.system.course-period': '营期管理',
  'menu.system': '系统设置',
  'menu.system.course': '训练营管理',
  'menu.system.product': '商品管理',
  'menu.system.channel': '渠道管理',
  'menu.system.team': '团队管理',
  'menu.system.team.member': '成员管理',
  'menu.system.team.role': '角色管理',
  'menu.system.team.permission': '权限管理',
  'menu.system.team.data-permission': '数据权限管理',
  'menu.system.employee': '员工管理',
  'menu.system.data-protection': '数据保护',
  'menu.system.fei-shu-table-config-mapping': '飞书表格映射',
  'menu.system.wechat-public-accounts': '微信公众号',
  'menu.system.wechat-mini-programs': '微信小程序',
  'menu.system.application-center': '应用中心',
  'menu.system.application-center.wechat-public-accounts': '微信公众号',
  'menu.system.application-center.wechat-mini-programs': '微信小程序',
  'menu.system.application-center.work-wx-apps': '企业微信',
  'menu.system.application-center.fei-shu-apps': '飞书',
};
